<template>
  <el-form
    :model="ruleForm"
    :rules="rules"
    ref="ruleForm"
    label-width="100px"
    class="demo-ruleForm"
  >
    <!-- 插槽推送给用户的内容 -->
    <slot name="context" :ruleForm="ruleForm"></slot>

    <el-card class="card" shadow="never">
      <div class="title">目标选择</div>
      <el-form-item label="目标用户" prop="type">
        <el-radio-group v-model="ruleForm.type" @change="typeUpdte">
          <el-radio label="0">全部用户</el-radio>
          <el-radio label="1">指定用户</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 展示全部用户 -->
      <div class="fixeddiv" v-show="ruleForm.type == 1">
        <keep-alive>
          <div>
            <my-search
              :inputArr="inputArr"
              :order="1"
              :searchParams="searchParams"
              @searchEvent="searchEvent"
            />
            <!-- 表格展示查询的数据  -->
            <myTable
              ref="user"
              isSelection
              :loading="loading"
              :tableData="allUser"
              :tableHeader="tableHeader"
              @handleSelectionChange="handleSelectionChange"
            />
            <!-- 分页器 -->
            <my-pagination :childMsg="pageParams" @callFather="callFather" />
          </div>
        </keep-alive>
      </div>

      <!-- 推送按钮 -->
      <div class="button" v-if="isBtnShow">
        <el-button type="primary" @click="submitForm('ruleForm')"
          >推送</el-button
        >
        <el-button @click="resetForm('ruleForm')">重置</el-button>
      </div>
    </el-card>
  </el-form>
</template>

<script>
import { push, allUserList } from "@/network/autopush/message";
import mixins from "@/mixins/common";
import { canSearch } from "../../utils/utils";
export default {
  mixins: [mixins],
  props: {
    rules: {
      type: Object,
      default: function () {
        return {};
      },
    },
    isBtnShow: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      inputArr: [
        {
          name: "userZh",
          defaultText: "请输入用户名称",
        },
      ],
      searchParams: { userZh: "" },
      tableHeader: Object.freeze([
        {
          name: "用户",
          prop: "userZh",
        },
      ]),
      // 推送携带字段
      ruleForm: {
        cids: [],
        title: "",
        context: "",
        docId: "",
        type: "1",
      },
      allUser: [],
      checkedUser: [],
    };
  },
  methods: {
    async getInitData(isSearch) {
      let params = {
        current: isSearch ? 1 : this.pageParams.currentPage,
        size: this.pageParams.pageSize,
        data: {
          userZh: this.searchParams.userZh,
        },
      };
      let { data } = await allUserList(params);
      // console.log("allUserList data");
      if (data.code == 200) {
        this.allUser = data.data.records;
        this.pageParams.total = data.data.total;
        this.loading = false;
        if (isSearch) this.pageParams.currentPage = 1;
      }
    },
    // 推送按钮
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          // 如果是指定客户需要收集cids字段
          if (this.ruleForm.type == "1") {
            // 判断选中用户是否为空
            if (!this.checkedUser.length) {
              this.$message({
                message: "推送用户不能为空",
                type: "warning",
              });
              return;
            }
            this.checkedUser.forEach((item) => {
              this.ruleForm.cids.push(item.clientId);
            });
          }
          // 请求推送
          let { data } = await push(this.ruleForm);
          if (data.code == "200") {
            this.$message({
              message: "推送成功",
              type: "success",
            });
            this.ruleForm.title = "";
            this.ruleForm.context = "";
            this.ruleForm.cids = [];
            this.ruleForm.docId = "";
            // 清空选中项和文本框的内容
            this.$bus.$emit("clearSelection");
          }
        } else {
          this.$message({
            message: "推送内容不能为空",
            type: "warning",
          });
        }
      });
    },
    // 重置按钮
    resetForm(formName) {
      this.$bus.$emit("clearSelection");
    },
    typeUpdte(value) {
      this.ruleForm.cids = [];
    },

    //接口用的时候传给组件
    async searchEvent() {
      if (canSearch(this, this.searchParams)) return;
      // console.log("搜索了");
      this.$bus.$emit("clearSelection");
      this.getInitData(true);
    },
    // 收集选中的用户
    handleSelectionChange(val) {
      this.checkedUser = val;
      this.$emit("handleSelectionChange", val);
    },
  },
};
</script>


<style scoped>
.title {
  height: 50px;
  line-height: 50px;
  font-size: 20px;
  color: #333;
  border-bottom: 1px solid #f4f2f0;
  margin-bottom: 20px;
}
.button {
  margin-top: 20px;
  margin-left: 25px;
}
.card {
  margin-top: 20px;
  margin-bottom: 20px;
}
.fixeddiv {
  margin-left: 20px;
}
.el-row {
  margin-bottom: 10px;
}
</style>
